module.exports = __webpack_public_path__ + "static/media/NuevoPack2.c9c459f0.JPG";